export default {
  productCategories: state => {
    return state['product-categories']
  }
}
